import { REVISAO } from "../../../nova-obra.constants";
import type { SecaoProps } from "./types-secao";

export function useSecao({ id, titulo }: SecaoProps) {
  return {
    testIds: { secao: `revisao-secao-${id}`, editar: `revisao-editar-${id}` },
    rotuloEditar: `${REVISAO.editar} ${titulo}`,
  };
}
